import { useCallback, useEffect, useState } from 'react'
import * as S from './styles'
import OperationHelper from '../../../../helpers/operation-result'
import { OperationState } from '../../../../view_models/operation-state'
import { Spinner } from '@monorepo/components'
import { HomepageCarouselSlide } from '../../../../models/homepage-carousel/homepage-carousel-slide'
import { HomepageCarouselHelper } from '../../../../helpers/homepage-carousel-helper'
import { OperationResult } from '@monorepo/components/src/models/operation-result'
import HomepageCarouselRowsComponent from '../../../organisms/HomepageCarouselConfig/HomepageCarouselRowsComponent'

const getSlidesAsync = async (
    channel: string
): Promise<OperationResult<HomepageCarouselSlide[], string>> => {
    return HomepageCarouselHelper.getChannelSlidesAsync(channel)
}

const loadSlidesAsync = async (
    channel: string,
    setSlidesOperationState: (
        state: OperationState<HomepageCarouselSlide[], string>
    ) => void
) => {
    await OperationHelper.handleRequestAsync(
        () => getSlidesAsync(channel),
        setSlidesOperationState,
        'Error',
        (_) => 'Error'
    )
}

export interface ChannelHomepageCarouselTemplateProps {
    channel: string
}

const ChannelHomepageCarouselTemplate: React.FC<ChannelHomepageCarouselTemplateProps> =
    (props) => {
        const [slidesOperationState, setSlidesOperationState] = useState<
            OperationState<HomepageCarouselSlide[], string>
        >({ kind: 'loading' })

        useEffect(() => {
            loadSlidesAsync(props.channel, setSlidesOperationState)
        }, [props.channel])

        const handleSlidesAdded = useCallback(
            (newSlides: HomepageCarouselSlide[]) => {
                setSlidesOperationState((prev) => {
                    if (prev.kind !== 'success') return prev
                    return { kind: 'success', data: [...prev.data, ...newSlides] }
                })
            },
            []
        )

        const handleSlideDeleted = useCallback(
            (slideId: string) => {
                setSlidesOperationState((prev) => {
                    if (prev.kind !== 'success') return prev
                    return {
                        kind: 'success',
                        data: prev.data.filter((s) => s._id !== slideId),
                    }
                })
            },
            []
        )


        return (
            <>
                <S.MainBox>
                    {slidesOperationState.kind === 'loading' && (
                        <S.SpinnerBox>
                            <Spinner />
                        </S.SpinnerBox>
                    )}
                    {slidesOperationState.kind === 'error' && (
                        <S.ErrorBox>{slidesOperationState.error}</S.ErrorBox>
                    )}
                    {slidesOperationState.kind === 'success' && (
                        <S.ContentBox>
                            <HomepageCarouselRowsComponent
                                slides={slidesOperationState.data}
                                channel={props.channel}
                                onSlidesAdded={handleSlidesAdded}
                                onSlideDeleted={handleSlideDeleted}
                            />
                        </S.ContentBox>
                    )}
                </S.MainBox>
            </>
        )
    }

export default ChannelHomepageCarouselTemplate
